import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { playgroundTypes, playgroundActions } = createActionsStructure('playground', [
  { name: 'GET_ALL_BOOKINGS', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/PlaygroundActions.js